/* eslint-disable no-param-reassign */
import { axiosCashJournalClient } from "../api";
import { MIDDLE_URL } from "../config";
import { IPostResponse } from "../masterDepartmentService";
import {
  IResponseUserPositionInfo,
  IGetUserPositionData,
  IGetUserPositionResponse,
  IResponseUser,
  IEmployeeMutationPayload,
  IParamsMutationUserHistory,
  IResponseHistoryMutation,
  IParamsUserList,
} from "./types";

export const URL = {
  USER_POSITION: "/v1/smplmstuserposition",
  USER_POSITION_EMAIL: (email: string) => `/v1/useraccount/userpositionemail/${email}`,
  USER: "/v1/useraccount",
  USER_MUTATION: "/v1/smplmutasi/user/department-pool",
  HISTORY_USER_MUTATION: "/v1/smplmutasi/user/history",
};

// const baseURL = "http://stg-bbone-fi-simple.internal.bluebird.id";

export const getUserPosition = async (
  email: string,
): Promise<IGetUserPositionResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_POSITION}/employeeemail/${email}/isactive/true`,
    method: "GET",
  });

  return data;
};

interface IGetUserPositionsPayload {
  pool_id?: string | string[],
  department?: string | string[],
  client_name?: string,
  search?: string,
  page_number?: number,
  page_size?: number,
  id?: number,
}

export type postUserPositionType = {
  code_type: string;
  area_id: string;
  pool_id: string;
  employee_id: string;
  employee_name: string;
  job_title: string;
  department: string;
  code_segment?: string;
  roles: string;
  create_by: string;
}

export type postUserPositionlist = {
  assignment_users: postUserPositionType[]
}

export type putUserPosition = {
  id: number;
  employee_id: string;
  employee_name: string;
  employee_email: string;
  update_by: string;
}

export const getUserPositions = async (
  payload: IGetUserPositionsPayload,
): Promise<IGetUserPositionResponse | IGetUserPositionData> => {
  const stringUser = `${MIDDLE_URL}${URL.USER_POSITION}${payload.id ? `/id/${payload.id}` : ""}`;
  delete payload.id;
  const { data } = await axiosCashJournalClient({
    url: stringUser,
    method: "GET",
    params: payload,
  });

  return data;
};

export const postUserPosition = async (payload: postUserPositionlist): Promise<IPostResponse> => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_POSITION}/assignment-users/bulky`,
    method: "POST",
    data: payload,
  });

  return res.data;
};

export const updateUserPosition = async (payload: putUserPosition) => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_POSITION}`,
    method: "PUT",
    data: payload,
  });

  return res.data;
};

export const deleteUserPosition = async (payload: {
  id: number;
  employee_id: string;
  update_by: string
}): Promise<IPostResponse> => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_POSITION}`,
    method: "DELETE",
    data: payload,
  });
  return res.data;
};

export const getMutationUserDetailByEmail = async (email: string):
Promise<IResponseUserPositionInfo> => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_POSITION_EMAIL(email)}`,
    method: "GET",
  });
  return res.data;
};

export const getMutationUserOptions = async (params: IParamsUserList):
Promise<IResponseUser> => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER}`,
    params,
    method: "GET",
  });
  return res.data;
};

export const mutateUserPosition = async (payload: IEmployeeMutationPayload) => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.USER_MUTATION}`,
    method: "PUT",
    data: payload,
  });
  return res.data;
};

export const getMutationUserHistory = async (params: IParamsMutationUserHistory):
Promise<IResponseHistoryMutation> => {
  const res = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${URL.HISTORY_USER_MUTATION}`,
    params: {
      ...params,
      sort_by: "create_at",
      sort_type: "DESC",
      page_size: 10,
    },
    method: "GET",
  });
  return res.data;
};
